module.exports = require("react-dom");


//////////////////
// WEBPACK FOOTER
// external {"commonjs2":"react-dom"}
// module id = 14
// module chunks = 0